'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$81() {
  this.bmW = null;
  this.bmX = false;
}
export { $c_Lpresto_PrestoRouter$$anon$81 as $c_Lpresto_PrestoRouter$$anon$81 };
$p = $c_Lpresto_PrestoRouter$$anon$81.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$81;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$81() {
}
export { $h_Lpresto_PrestoRouter$$anon$81 as $h_Lpresto_PrestoRouter$$anon$81 };
$h_Lpresto_PrestoRouter$$anon$81.prototype = $p;
$p.bY = (function() {
  if ((!this.bmX)) {
    this.bmW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bmX = true;
  }
  return this.bmW;
});
$p.P = (function() {
  return this.bY();
});
var $d_Lpresto_PrestoRouter$$anon$81 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$81, "presto.PrestoRouter$$anon$81", ({
  OZ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$81 as $d_Lpresto_PrestoRouter$$anon$81 };
//# sourceMappingURL=presto.-Presto-Router$$anon$81.js.map
